import { render, staticRenderFns } from "./LookupTag.vue?vue&type=template&id=697e4b50&"
import script from "./LookupTag.vue?vue&type=script&lang=ts&"
export * from "./LookupTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports